module.exports = __webpack_public_path__ + "img/zhishitupu.f850b107.png";